'use strict';

var BASE_URL = 'https://downloads-uat.sandbox.dbt.svs.nike.com/',
  DOWNLOAD_URL = {
    base: BASE_URL,
  };

module.exports = DOWNLOAD_URL;
